'use client';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';
import {YANDEX_METRIKA_ID} from '@web-landing/analytics/ids';

export const onSocialClick = (event: React.MouseEvent) => {
  logTmrEvent(EVENTS.footerNetworkClick, {
    social_link: event.currentTarget.getAttribute('href') ?? '',
  });
};

export const onFooterClick = ({title}: {title: string}) => {
  logTmrEvent(EVENTS.footerClick, {
    button_text: title,
  });

  window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'footer_click');
};
